import { Link } from 'gatsby'
import { truncate } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'

const TipsheetCard = ({
  title,
  image,
  description,
  slug,
  category,
  loading,
}) => (
  <div className="bg-white shadow-sm rounded overflow-hidden relative">
    {image && (
      <Link to={`/${category.slug}/${slug}/`}>
        <GatsbyImage
          image={image.gatsbyImageData}
          alt={title}
          title={title}
          className="h-56 w-full object-cover object-center"
          loading={loading}
        />
      </Link>
    )}
    <div className="p-4">
      <Link className="block" to={`/${category.slug}/${slug}/`}>
        <h3 className="text-gray-600 font-bold text-xl mb-2">{title}</h3>
      </Link>
      {description && (
        <p className="mt-2 text-gray-600 text-sm leading-relaxed block lg:text-xs lg:text-sm">
          {truncate(description.description, { length: 140, separator: ' ' })}
        </p>
      )}
    </div>
  </div>
)

TipsheetCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    description: PropTypes.string.isRequired,
  }),
  image: PropTypes.object,
  slug: PropTypes.string,
  category: PropTypes.shape({
    slug: PropTypes.string.isRequired
  }),
  loading: PropTypes.string.isRequired
}

export default TipsheetCard
